import React from 'react';
import classnames from 'classnames/bind';
import { ArrowDropDownIcon } from 'tuui';
import { Dotdotdot } from 'taboola-ultimate-ui';
import styles from './BreadcrumbsDropdownControl.module.scss';

const classNameBuilder = classnames.bind(styles);

export const BreadcrumbsDropdownControl = ({ label, value, isOpen, openDropdown, dataAutomationId, dataTestId }) => {
    return (
        <div className={classNameBuilder('container')} data-testid={dataTestId}>
            <div className={classNameBuilder('label')}>{label}</div>
            <div
                className={classNameBuilder('value-container', { open: isOpen })}
                onClick={openDropdown}
                data-automation={`control-${dataAutomationId}`}
            >
                <div className={classNameBuilder('value')}>
                    <Dotdotdot lines={1} className={classNameBuilder('value-dots')}>
                        {value}
                    </Dotdotdot>
                </div>
                <ArrowDropDownIcon fontSize="small" />
            </div>
        </div>
    );
};
